module.exports = __webpack_public_path__ + "static/media/galeryAbout2.f8a26059.jpg";